import { render, staticRenderFns } from "./PendingCoinsVerifier.vue?vue&type=template&id=bfa0e826&scoped=true&"
import script from "./PendingCoinsVerifier.vue?vue&type=script&lang=ts&"
export * from "./PendingCoinsVerifier.vue?vue&type=script&lang=ts&"
import style0 from "./PendingCoinsVerifier.vue?vue&type=style&index=0&id=bfa0e826&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0e826",
  null
  
)

export default component.exports